import React from 'react';

const ArrowLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    {...props}
  >
    <path
      d="M1.33301 4.00049L11.333 4.00049"
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99902 7.3335L1.13709 4.47157C0.914872 4.24935 0.803761 4.13823 0.803761 4.00016C0.803761 3.86209 0.914872 3.75098 1.13709 3.52876L3.99902 0.666829"
      stroke="#002564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeft;
